/**
 * Ligação da BFF do Agents no boot: URL e ID token. Sem zod nem cliente, para não pesar no JS inicial.
 */
export interface AgentsRuntime {
  /** `AGENTS_BFF_URL` da config; vazio ou ausente faz toda chamada falhar com `not-configured`. */
  readonly baseUrl: string | null | undefined;
  /** ID token do Cognito (tem `aud`), pedido a cada chamada e a cada reconexão (G39). */
  readonly getIdToken: () => Promise<string | undefined> | string | undefined;
  /** Troca o `fetch` (testes). Sem ele, usa o `globalThis.fetch` do momento da chamada. */
  readonly fetch?: typeof fetch;
}

let runtime: AgentsRuntime = { baseUrl: undefined, getIdToken: () => undefined };

/** Liga o cliente da BFF do Agents; a casca chama no boot com a config e a sessão. */
export function configureAgentsHttp(next: AgentsRuntime) {
  runtime = next;
}

/** O runtime corrente, lido a cada chamada. */
export function getAgentsRuntime(): AgentsRuntime {
  return runtime;
}
